<template>
  <div class="payment-container">
    <div class="stripe-container" @click="currentType = 'stripe'">
      <div class="item-row mt15">
        <div class="payment-info">
          <span class="payment-name">Credit Card</span>
          <span
            class="payment-des"
          >Safe money transfer using your bank account. Visa, Maestro, Discover, American Express.</span>
        </div>
      </div>
      <div class="stripe-card">
        <card :stripe="publishableKey" @change="stripeComplete = $event.complete" />
      </div>

      <span class="label-name-card mt15">NAME ON CARD</span>

      <div class="stripe-card" style="margin-top: 6px;">
        <input class="input-card-info" />
      </div>
      <img src="@/assets/stripe.png" class="img-stripe" />
    </div>
    <!-- <div class="paypal-container">
      <div class="item-row mt15">
        <div class="payment-info">
          <span class="payment-name">Paypal</span>
          <span
            class="payment-des"
          >You will be redirected to PayPal website to complete your purchase securely.</span>
        </div>
      </div>
    </div>
    <pay-pal
      :amount="`${totalAmount}`"
      currency="USD"
      :client="paypalClient"
      class="btn-paypal"
      :button-style="paypalStyle"
      :env="paypalEnv"
      @payment-authorized="paypalAuthorized"
      @payment-completed="paypalCompleted"
      @payment-cancelled="paypalCancelled"
    />
    <span
      class="payment-note"
    >* By purchasing this gift card, you confirm that you have permission to send text messages to the mobile phone number entered above. Message and data rates may apply.</span> -->
    <div class="checkout-bottom">
      <div class="checkout-info">
        <span class="text">Total</span>
        <span class="text">${{totalAmount}}</span>
      </div>
      <gradient-button
        class="cta-bottom"
        title="Complete Order"
        @onClick="onCharge"
        :isActive="ctaActive"
      />
    </div>
    <loading :active.sync="isLoading" class="payment-loading" />
    <purchase-success-alert
      v-if="isComplete"
      @onDismiss="onDismiss"
      :infoName="infoName"
      :infoPhone="infoPhone"
      :storeName="storeData.store_display_name"
      @onHomeClick="onHomeClick"
    />
  </div>
</template>
<script>
import { Card, createToken } from "vue-stripe-elements-plus";
import GradientButton from "@/components/GradientButton";
import { chargeStripe } from "@/api/payment";
// import PayPal from "vue-paypal-checkout";
import { mapGetters } from "vuex";
import store from "@/store";
import Loading from "vue-loading-overlay";
import PurchaseSuccessAlert from "@/components/PurchaseSuccessAlert";

export default {
  name: "Payment",
  data() {
    return {
      stripeComplete: false,
      isLoading: false,
      isComplete: false,
      infoName: "",
      infoPhone: "",
      publishableKey: process.env.VUE_APP_STRIPE_PK,
      token: null,
      charge: null,
      paypalEnv: process.env.VUE_APP_PAYPAL_ENV,
      paypalClient: {
        [process.env.VUE_APP_PAYPAL_ENV]: process.env.VUE_APP_PAYPAL_CLIENT_ID
      },
      paypalStyle: {
        label: "pay",
        size: "large",
        shape: "rect",
        color: "gold",
        tagline: false
      }
    };
  },
  components: {
    Card,
    GradientButton,
    // PayPal,
    Loading,
    PurchaseSuccessAlert
  },
  computed: {
    ...mapGetters(["paymentInfo", "storeData"]),
    totalAmount() {
      let amount = 0;
      const items = this.$store.state.cart.items;
      items.forEach(item => {
        amount += item.egift_amount;
      });
      return amount;
    },
    ctaActive() {
      return this.complete;
    },
    paypalCompleted() {
      const self = this;
      return res => {
        console.log(res);
        self.sendDataToServer(res, "paypal");
      };
    },
    paypalAuthorized: res => {
      console.log(res);
    },
    paypalCancelled: res => {
      console.log(res);
    }
  },
  methods: {
    onHomeClick() {
      window.location.href = this.storeData.store_main_url;
    },
    onDismiss() {
      this.isComplete = false;
      this.$router.replace("/");
    },
    sendDataToServer(res, method = "stripe") {
      let amount = 0;
      const items = [];
      store.state.cart.items.forEach(item => {
        amount += item.egift_amount;
        items.push({ egift_product_id: item.id });
        if (item.voucher_id) {
          items.push({ egift_product_id: item.voucher_id });
        }
      });

      const storeData = store.state.eGiftCard.dataStore;
      const data = {
        store_id: storeData.id,
        total_amount: amount,
        payment_method: method,
        payment_status: "success",
        payment_data: JSON.stringify(res),
        items,
        ...store.state.cart.paymentInfo
      };

      store
        .dispatch("cart/checkoutCart", data)
        .then(res => {
          this.infoName = res.info.recipient_name;
          this.infoPhone = res.info.recipient_phone_number;
          this.isLoading = false;
          this.isComplete = true;
        })
        .catch(e => {
          this.isLoading = false;
          console.log(e);
        });
    },
    onCharge() {
      if (!this.stripeComplete) return;
      this.isLoading = true;
      const self = this;
      createToken().then(async data => {
        console.log(self.totalAmount);
        const params = new URLSearchParams();
        params.append("amount", `${self.totalAmount * 100}`);
        params.append("currency", "usd");
        params.append("description", "eGiftCard Charge");
        params.append("source", data.token.id);
        try {
          const res = await chargeStripe(params);
          this.sendDataToServer(res);
        } catch (e) {
          console.log(e);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.payment-loading {
  position: absolute;
  top: 50px;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba($color: #fff, $alpha: 0.5);
  z-index: 100;
}
.payment-container {
  display: flex;
  flex-direction: column;
  padding-left: 70px;
  padding-right: 70px;
  min-height: calc(100vh - 50px);
  background-color: white;
  .stripe-container {
    display: flex;
    flex-direction: column;
    padding: 30px 0 40px 0;
    margin: 0 20px;
    // border-bottom: 1px solid #979797;
  }
  .paypal-container {
    display: flex;
    flex-direction: column;
    margin: 45px 20px 0 20px;
  }
  .item-row {
    display: flex;
    .img-radio {
      width: 18px;
      height: 18px;
    }
    .payment-info {
      display: flex;
      flex-direction: column;
      .payment-name {
        font-family: "SFProText-Semibold", -apple-system;
        font-weight: 600;
      }
      .payment-des {
        color: #788995;
        line-height: 26px;
        margin-top: 7px;
      }
    }
    .card-number {
      color: #d4d9dd;
      size: 12px;
      font-family: "SFProText-Semibold", -apple-system;
      font-weight: 600;
    }
  }
  .label-name-card {
    color: #d4d9dd;
    font-size: 12px;
    font-family: "SFProText-Semibold", -apple-system;
    font-weight: 600;
  }
  .stripe-card {
    border: 1px solid #dde3e8;
    border-radius: 3px;
    padding: 15px 20px;
    margin-top: 30px;

    .input-card-info {
      width: 100%;
      outline: none;
      outline-style: none;
      box-shadow: none;
      border: 0;
      color: #d4d9dd;
      text-transform: uppercase;
    }
  }
  .img-stripe {
    width: 90px;
    height: auto;
    position: absolute;
    top: 80px;
    right: calc(50% - 280px);
  }
  .img-paypal {
    margin-top: 24px;
    align-self: flex-end;
    width: 90px;
    height: auto;
    margin-right: 20px;
  }
  .btn-paypal {
    margin-top: 30px;
    align-self: center;
  }
  .payment-note {
    margin: 60px 20px 180px 20px;
    font-family: "SFProText-Medium" -apple-system;
    font-weight: 500;
    font-size: 16px;
  }
  .checkout-bottom {
    position: fixed;
    bottom: 0;
    left: calc(50% - 300px);
    right: calc(50% - 300px);
    z-index: 100;
    display: flex;
    flex-direction: column;
    background-color: white;
    padding: 20px 70px 30px 70px;
    .checkout-info {
      display: flex;
      justify-content: space-between;
      .text {
        font-size: 24px;
        font-family: "SFProText-Bold", -apple-system;
        font-weight: bold;
      }
    }
    .cta-bottom {
      margin-top: 30px;
    }
  }
}
@media only screen and (max-width: 600px) {
  .payment-container {
    padding-left: 0;
    padding-right: 0;
    .checkout-bottom {
      left: 0;
      right: 0;
      padding: 20px 20px 30px 20px;
    }
    .checkout-disable {
      left: 0;
      right: 0;
    }
    .img-stripe {
      right: 20px;
    }
  }
}
</style>